//External
import React, { useEffect, useState } from "react";
import { Button, Form, Badge } from "react-bootstrap";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
//Internal
import TimePicker from "../../components/time-picker";
import DateRangePicker from "../../components/date-range";
import {
  breakDown,
} from "utils/reservation";
import {
  clearTimeDateCookieValue,
  formatMoney,
  formatMoneyLocalString,
  get_cookie,
  minimumDayErrorMessage,
  set_cookie,
  remove_cookie,
} from "utils";
import { getAvailableSlot } from "store/actions";
import moment from "moment";
import { ButtonLoader } from "components/loader/ButtonLoader";
import EarliestStartHint from "components/earliest-start-hint";

/*******************
  @Purpose :  used for car price box
  @Parameter : {}
  @Author : INIC
 *******************/
const CarPriceBox = ({ vehicalDetailData, globalSetting, startDate,
  endDate,
  startTimeDefaultValue,
  endTimeDefaultValue, setStartTimeDefaultValue, setEndTimeDefaultValue, setEndDate, setStartDate }) => {
  const router = useRouter();
  const dispatch = useDispatch()
  const user = useSelector((state) => state?.user);
  const [loaders, setLoaders] = useState(false)
  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState("");
  const [breakDownObj, setBreakDownObj] = useState({});
  const stateObj = [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ];

  // time options
  const [startDateTimeOptions, setStartDateTimeOptions] = useState([]);
  const [endDateTimeOptions, setEndDateTimeOptions] = useState([]);
  // const [startTimeDefaultValue, setStartTimeDefaultValue] = useState();
  // const [endTimeDefaultValue, setEndTimeDefaultValue] = useState();
  const [isShowCalendar, setIshowCalendar] = useState(false);
  const [dateObj, setDateObj] = useState(stateObj);
  const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);
  const [isReserveEnable, setIsReserveEnable] = useState(true);

  const [minDayErrorMessage, setMinDayErrorMessage] = useState("");
  const [noSlotError, setNoSlotError] = useState("")
  const [noVehicleError, setNoVehicleError] = useState("");
  const [minimumDay, setMinimumDay] = useState(1);

  useEffect(() => {
    setStartDate(null);
    setEndDate(null);
    setBreakDownObj({});
    setStartDateTimeOptions([]);
    setEndDateTimeOptions([]);
    setStartTimeDefaultValue("");
    setEndTimeDefaultValue("");
    setIshowCalendar(false);
    setDateObj(stateObj);
    setIsFirstTimeLoad(true);
    setIsReserveEnable(true);
    setMinDayErrorMessage("");
    setNoSlotError("")
    setNoVehicleError("")
    setMinimumDay(
      vehicalDetailData?.minimum_days ? vehicalDetailData.minimum_days : 1
    );
  }, [vehicalDetailData]);

  /******************* 
  @purpose : select time as per scenario
  @Parameter : {}
  @Author : INIC
  ******************/
  /* useEffect(() => {
    if (startDateTimeOptions.length > 0) {
      let index = 0;
      if (startDate) {
        if (
          (startDate == endDate && isTodayDate(dateObj[0].startDate)) ||
          isTodayDate(dateObj[0].startDate)
        ) {
          if (startDateTimeOptions.length > 0) {
            index = startDateTimeOptions[0]["id"];
          } else {
            index = 0;
          }
        } else {
          if (startDateTimeOptions.length > 0) {
            index = startDateTimeOptions[2]["id"];
          } else {
            index = 0;
          }
        }
      }
      setStartTimeDefaultValue(index);
      if (endDate) {
        if (startDate == endDate) {
          let tempEndObj = [];
          startDateTimeOptions.forEach(function (row) {
            if (row.id > index) {
              tempEndObj.push(row);
            }
          });
          setEndDateTimeOptions(tempEndObj);
        } else {
          let tempObj = "";
          if (isWeekendDate(dateObj[0].endDate)) {
            tempObj = getTimeOptions("weekend");
          } else {
            tempObj = getTimeOptions("other");
          }
          setEndDateTimeOptions(tempObj);
        }
      }
    } else {
      setEndDateTimeOptions([]);
      setIsReserveEnable(true);
    }
  }, [startDateTimeOptions]); */
  /*******************
  @Purpose :  used for setEndTimeDefaultValue
  @Parameter : {}
  @Author : INIC
 *******************/
  useEffect(() => {
    if (endDate) {
      if (
        startTimeDefaultValue === endTimeDefaultValue ||
        endTimeDefaultValue === `${parseInt(startTimeDefaultValue) + 1}:00`
      ) {
        changeTimeBreakDown();
      }
    } else {
      setBreakDownObj({});
      setIsReserveEnable(true);
    }
  }, [endDate, endTimeDefaultValue]);




  /*******************
  @Purpose :  used for change breakdown time
  @Parameter : {}
  @Author : INIC
  *******************/
  useEffect(() => {
    changeTimeBreakDown();
  }, [startTimeDefaultValue, endTimeDefaultValue, endDate]);
  /*******************
  @Purpose :  used for change breakdown time
  @Parameter : {}
  @Author : INIC
  *******************/
  const changeTimeBreakDown = () => {
    if (!isFirstTimeLoad) {
      if (endTimeDefaultValue) {
        commonBreakDown();
        setIsReserveEnable(false);
      } else {
        setBreakDownObj({});
        setIsReserveEnable(true);
      }
    }
  };

  /*******************
  @purpose : open calender and hide calender with time options set
  @Parameter : {}
  @Author : INIC
  ******************/
  const handleClickOpenCalendar = () => {
    setIshowCalendar(!isShowCalendar);
  };

  // See components/vehicle/index.js's handleClickOpenCalendar for why this
  // is state-driven instead of an imperative classList.toggle().
  useEffect(() => {
    document.body.classList.toggle("model-active", isShowCalendar);
    document.body.classList.toggle("vehicle-calendar-open", isShowCalendar);
    return () => {
      document.body.classList.remove("model-active");
      document.body.classList.remove("vehicle-calendar-open");
    };
  }, [isShowCalendar]);

  /*******************
  @purpose : Set start options and end options
  @Parameter : {date}
  @Author : INIC
  ******************/
  const startTimeOptionsHandler = (dateObj1) => {
    setIsFirstTimeLoad(false);
    // process on date
    // let tempStartDateFlag = "";
    // /*******************
    //   @purpose : start date and time selection login start here
    //   @Author : INIC
    //   ******************/
    // // Today  login start here
    // if (isTodayDate(dateObj1.startDate) && isWeekendDate(dateObj1.startDate)) {
    //   tempStartDateFlag = "todayweekend";
    //   setStartDateTimeOptions(getTimeOptions(tempStartDateFlag));
    // } else if (isTodayDate(dateObj1.startDate)) {
    //   tempStartDateFlag = "today";
    //   setStartDateTimeOptions(getTimeOptions(tempStartDateFlag));
    // }
    // // weekend login start here
    // else if (isWeekendDate(dateObj1.startDate)) {
    //   tempStartDateFlag = "weekend";
    //   setStartDateTimeOptions(getTimeOptions(tempStartDateFlag));
    // }
    // // other day login start here
    // else {
    //   tempStartDateFlag = "other";
    //   setStartDateTimeOptions(getTimeOptions(tempStartDateFlag));
    // }
  };

  /*******************
  @purpose : Set start date and end date in respective fields
  @Parameter : {dateObj}
  @Author : INIC
  ******************/
  const setStartEndDateOnChange = (dateObj2) => {
    setNoVehicleError("")
    setNoSlotError("")
    setMinDayErrorMessage("")
    setEndTimeDefaultValue(null)
    setStartTimeDefaultValue(null)
    if (
      dateObj2 &&
      Object.keys(dateObj2).length === 0 &&
      Object.getPrototypeOf(dateObj2) === Object.prototype
    ) {
      setDateObj(stateObj);
      setStartDate(null);
      setEndDate(null);
      setStartDateTimeOptions([]);
      setEndDateTimeOptions([]);
      setStartTimeDefaultValue(0);
      setEndTimeDefaultValue(0);
    } else {
      setDateObj([dateObj2]);
      setStartDate(format(dateObj2.startDate, "MMM d, yyyy", {}));
      setEndDate(format(dateObj2.endDate, "MMM d, yyyy", {}));
    }
  };

  /*******************
  @purpose : time change handler
  @Parameter : {}
  @Author : INIC
  ******************/
  const parentTimeChangeHandler = (index, currentObjName) => {
    if (currentObjName != "endDateTime") {
      setStartTimeDefaultValue(index);

      // if (startDate == endDate) {
      //   let tempEndObj = [];
      //   startDateTimeOptions.forEach(function (row) {
      //     if (row.id > index) {
      //       tempEndObj.push(row);
      //     }
      //   });
      //   setEndDateTimeOptions(tempEndObj);
      // } else {
      //   if (isWeekendDate(dateObj[0].endDate)) {
      //     if (index > 18) {
      //       setEndTimeDefaultValue(18);
      //     } else {
      //       setEndTimeDefaultValue(index);
      //     }
      //   } else {
      //     setEndTimeDefaultValue(index);
      //   }
      // }
    } else {
      setEndTimeDefaultValue(index);
    }
  };

  /*******************
  @purpose : call breakdown function
  @Parameter : {}
  @Author : INIC
  ******************/
  const commonBreakDown = () => {
    if (!isFirstTimeLoad) {
      const obj = breakDown(
        vehicalDetailData,
        dateObj,
        startTimeDefaultValue,
        endTimeDefaultValue,
        user?.userInfo?.date_of_birth,
        globalSetting
      );
      setBreakDownObj(obj);
    }
  };
  useEffect(() => {
    clearTimeDateCookieValue()
  }, [])

  /*******************
  @purpose : redirect to vehical booking
  @Parameter : {}
  @Author : INIC
  ******************/
  const onClickHandler = async () => {
    if (breakDownObj.days >= vehicalDetailData.minimum_days) {
      setLoaders(true);
      if (vehicalDetailData?.id) {
        // Calculate start and end dates for the two-month period
        const start_date = moment(startDate).format("YYYY-MM-DD");
        const end_date = moment(endDate).format("YYYY-MM-DD");
        const startTime = startTimeDefaultValue
        const endTime = endTimeDefaultValue
        const res = await dispatch(
          getAvailableSlot(
            get_cookie("currentLocationId"),
            vehicalDetailData?.id,
            start_date,
            end_date, "submit", "", startTime?.replace(":00", ""), endTime.replace(":00", "")
          ))
        if (res && res?.common_vehicles?.length > 0 && res?.event === "submit") {
          const daterange = startDate + "|" + endDate;
          const timerange = startTimeDefaultValue + "|" + endTimeDefaultValue;
          const vSlug = vehicalDetailData.slug;
          const brandId = vehicalDetailData.brand_detail.id;
          const vId = vehicalDetailData.id;

          set_cookie("brandId", brandId, 1);
          set_cookie("vId", vId, 1);
          set_cookie("vSlug", vSlug, 1);
          set_cookie("daterange", daterange, 1);
          set_cookie("timerange", timerange, 1);
          set_cookie("vehicleBookingBackUrl", router.asPath, 1);
          remove_cookie("selectedLocationDraft");
          setMinDayErrorMessage("");
          setNoSlotError("")
          setNoVehicleError("")
          //as per client reqirements we add delay to show full loader
          setTimeout(() => {
            router.push("/vehiclebooking");
          }, 1000);
        } else {
          setLoaders(false)
          setNoVehicleError("No vehicle available for this date, please select a different date range.");
        }
      }
    } else {
      setLoaders(false)
      setMinDayErrorMessage(
        minimumDayErrorMessage(vehicalDetailData.minimum_days)
      );
    }
  };

  /*******************
  @purpose : Show error message which get by date range picker component
  @Parameter : {message}
  @Author : INIC
  ******************/
  const showMinimumErrorMessage = (message) => {
    setMinDayErrorMessage(message);
    if (message)
      setTimeout(() => {
        setIsReserveEnable(true);
      }, 500);
  };

  /*******************
  @purpose : Rander HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <div className="card time-range">
        <div className="d-flex align-items-start justify-content-between">
          <span className="d-flex align-items-end car-price">
            {vehicalDetailData.real_price ? (
              <span className="discounted_rate text-dark ff-hel-med">
                ${vehicalDetailData?.day}
              </span>
            ) : (
              <span className="discounted_rate text-black ff-hel-reg lh-1">
                ${vehicalDetailData?.day}
              </span>
            )}

            {vehicalDetailData.real_price ? (
              <>
                <small className="text-black">
                  <del>${vehicalDetailData?.real_price}</del>/day
                </small>
              </>
            ) : (
              <>
                <small>per day</small>
              </>
            )}
          </span>
          {vehicalDetailData?.special_note && (
            <Badge
              bg="primary"
              className="discount-badge text-truncate"
              title={vehicalDetailData?.special_note}
            >
              {vehicalDetailData?.special_note}
            </Badge>
          )}
        </div>
        {/* 
        {vehicalDetailData.availability == 2 && (
          <p className="content-title mb-0 ff-hel-reg font-30">
            Temporarily Unavailable
          </p>
        )} */}

        <Form className="select-date-range">
          <div className="d-flex input-field">
            <div className="floating-form">
              <Form.Group
                controlId="startDate123"
                className="floating-form-group"
                onClick={handleClickOpenCalendar}
              >
                <Form.Control
                  type="text"
                  className="floating-input pe-none"
                  placeholder="Start Date"
                  name="startDate"
                  defaultValue={startDate}

                // inputRef={register}
                />
                <Form.Label className="floating-label">
                  Start Date*
                </Form.Label>
              </Form.Group>
            </div>
            <div className="floating-form">
              <TimePicker
                timeOptions={startDateTimeOptions}
                defaultValue={startTimeDefaultValue}
                setStartTimeDefaultValue={setStartTimeDefaultValue}
                parentTimeChangeHandler={parentTimeChangeHandler}
                currentObjName="startDateTime"
                selectedDate={startDate}
                selectedStartDate={startDate}
                startTimeDefaultValue={startTimeDefaultValue}
                endTimeDefaultValue={endTimeDefaultValue}
                setNoSlotError={setNoSlotError}
                isShowCalendar={isShowCalendar}
              />
            </div>
          </div>

          <div className="d-flex input-field">
            <div className="floating-form">
              <Form.Group
                controlId="endDate"
                className="floating-form-group"
                onClick={handleClickOpenCalendar}
              >
                <Form.Control
                  type="text"
                  className="floating-input pe-none"
                  placeholder="End Date"
                  name="endDate"
                  defaultValue={endDate}
                />
                <Form.Label className="floating-label">End Date*</Form.Label>
              </Form.Group>
            </div>
            <div className="floating-form">
              <TimePicker
                timeOptions={endDateTimeOptions}
                defaultValue={endTimeDefaultValue}
                startTimeDefaultValue={startTimeDefaultValue}
                parentTimeChangeHandler={parentTimeChangeHandler}
                currentObjName="endDateTime"
                selectedDate={endDate}
                setEndTimeDefaultValue={setEndTimeDefaultValue}
                endTimeDefaultValue={endTimeDefaultValue}
                selectedEndDate={endDate}
                selectedStartDate={startDate}
                setNoSlotError={setNoSlotError}
                isShowCalendar={isShowCalendar}
              />
            </div>
          </div>

          <EarliestStartHint startDate={startDate} />

          {minDayErrorMessage && startDate && endDate && <span className="text-danger font-12 ff-hel-med d-block">
            {minDayErrorMessage}
          </span>}
          {noSlotError && endDate && <span className="text-danger font-12 ff-hel-med d-block">
            {noSlotError}
          </span>}
          {noVehicleError && noVehicleError && <span className="text-danger font-12 ff-hel-med d-block">
            {noVehicleError}
          </span>}
          <Button
            variant="primary"
            className={`w-100 btn-primary-light mt-2 gtStep1 ${loaders ? "btn-loader-size-s" : ""}`}
            disabled={loaders || !startDate && !endDate && !startTimeDefaultValue && !endTimeDefaultValue}
            onClick={onClickHandler}
          >
            {loaders ? <ButtonLoader /> : "Next"}

          </Button>
        </Form>

        {/* Rental Total Price List */}

        {breakDownObj.rentalCharge && (
          <ul className="list-unstyled mb-0 rental-list car-details-prices">
            <li>
              <div className="rental-charges">
                <span>
                  ${formatMoneyLocalString(breakDownObj.perDayCharge)} x{" "}
                  {breakDownObj.days}d
                </span>
                <span>${formatMoney(breakDownObj.rentalCharge)}</span>
              </div>

              {breakDownObj.hours > 0 && (
                <div className="rental-charges">
                  <span>
                    ${breakDownObj.perHourCharge} x {breakDownObj.hours}h
                  </span>
                  <span>${formatMoney(breakDownObj.totalHourCharge)}</span>
                </div>
              )}

              {breakDownObj.weeklyDiscount > 0 && (
                <div className="rental-charges">
                  <span>Weekly Discount</span>
                  <span className="text-success">
                    -${formatMoney(breakDownObj.weeklyDiscount)}
                  </span>
                </div>
              )}

              {breakDownObj.monthlyDiscount > 0 && (
                <div className="rental-charges">
                  <span>Monthly Discount</span>
                  <span className="text-success">
                    -${formatMoney(breakDownObj.monthlyDiscount)}
                  </span>
                </div>
              )}
              {breakDownObj.underageFee > 0 && (
                <div className="rental-charges">
                  <span>Underage Fee ({breakDownObj.underageFeePercent}%)</span>
                  <span>${formatMoney(breakDownObj.underageFee)}</span>
                </div>
              )}

              <div className="rental-charges">
                <span>Taxes & Fees</span>
                <span>${formatMoney(breakDownObj.taxesFees)}</span>
              </div>
            </li>

            <li className="rental-charges">
              <h3 className="mb-0 ff-hel-bold font-24">Total Charges</h3>
              <h3 className="mb-0 ff-hel-bold total-price font-24">
                ${formatMoney(breakDownObj.totalCharge)}
              </h3>
            </li>
          </ul>
        )}
      </div>

      {/* Date Range */}
      {isShowCalendar ? (
        <DateRangePicker
          dateObj={dateObj}
          setDateObj={setDateObj}
          handleClickOpenCalendar={handleClickOpenCalendar}
          setStartEndDateOnChange={setStartEndDateOnChange}
          startTimeOptionsHandler={startTimeOptionsHandler}
          setStartTimeDefaultValue={setStartTimeDefaultValue}
          setEndTimeDefaultValue={setStartTimeDefaultValue}
          isFirstTimeLoad={isFirstTimeLoad}
          tempDirections="horizontal"
          minimumDay={minimumDay}
          showMinimumErrorMessage={showMinimumErrorMessage}
          selectedStartDate={startDate}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          vehicleId={vehicalDetailData?.id}
          isVehcileDetailsPage={true}
          minDayError={minDayErrorMessage}
          isAvailable={vehicalDetailData?.availability !== 1}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default CarPriceBox;
